<app-page-header title="Home" active_item="Cash In" titleLink="/reports"  ></app-page-header>
<div class="loading-deposit" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.cashIn' | translate }}</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.paymentData' | translate}}</div>
      </div>
      <div class="card-body">
        <form [formGroup]="cashIn">
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDocumentoFavorecido" class="form-label">{{ 'common.payerDocument' | translate}} <span class="text-danger">*</span></label>
                <input *ngIf="originCurrency === 'BRL'" 
                      mask="CPF_CNPJ" 
                      [formControl]="cashIn.controls.documento" 
                      class="form-control"
                      [ngClass]="{'is-invalid state-invalid': cashIn.controls.documento.invalid && isSubmitted}"
                      type="text" 
                      name="documentoFavorecido" 
                      id="txtDocumentoFavorecido">
                <input *ngIf="originCurrency !== 'BRL'" 
                      [formControl]="cashIn.controls.documento" 
                      class="form-control"
                      [ngClass]="{'is-invalid state-invalid': cashIn.controls.documento.invalid && isSubmitted}"
                      type="text" 
                      name="documentoFavorecido" 
                      id="txtDocumentoFavorecido">
                <div class="invalid-feedback">{{documentFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtNomeFavorecido" class="form-label">{{ 'common.payerName' | translate}} <span class="text-danger">*</span></label>
                <input class="form-control" [ngClass]="{'is-invalid state-invalid': cashIn.controls.nome.invalid && isSubmitted}" [formControl]="cashIn.controls.nome" type="text" name="nomeFavorecido" id="txtNomeFavorecido" [required]="true">
                <div class="invalid-feedback">{{nomeFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <label for="slOrigin" class="form-label">{{ 'common.paymentMethod' | translate}}</label>
              <ng-select
              [items]="originList"
              bindValue="value"
              bindLabel="name"
              [formControl]="cashIn.controls.origem"
              [searchable]="false"
              [ngClass]="{
                          'is-invalid state-invalid':
                          cashIn.controls.origem.invalid && isSubmitted
                        }">
            </ng-select>
            <div class="invalid-feedback">{{origemFeedBack}}</div>
          </div>
          </div>
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label">{{ 'common.value' | translate}} <span class="text-danger">*</span></label>
                <input placeholder="{{ 0 | formatCurrency }}" [formControl]="cashIn.controls.valor" currencyMask [options]="{ prefix: ('' | currencySymbol) + ' ' }"
                       class="form-control" [ngClass]="{'is-invalid state-invalid': cashIn.controls.valor.invalid && isSubmitted}" type="text" name="valorSolicitado"
                        id="txtValorSolicitado" (focusout)="valorChanged()">
                <div class="invalid-feedback">{{valorFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTaxa" class="form-label">{{ 'common.fee' | translate}}</label>
                <input [prefix]="( '' | currencySymbol ) + ' '" [formControl]="cashIn.controls.taxa" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="taxa" id="txtTaxa" [readonly]="true">
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorTotal" class="form-label">{{ 'common.totalAmount' | translate}}</label>
                <input [prefix]="( '' | currencySymbol ) + ' '" [formControl]="cashIn.controls.valorTotal" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="valorTotal" id="txtValorTotal" [readonly]="true">
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <button type="button" class="our-button btn btn-pill btn-primary" (click)="makeDeposit()"><i class="fe fe-arrow-down-right"></i>{{ 'common.depositButton' | translate}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row mt-4" *ngIf="showCountryForm">
  <div class="col-12">
    <div class="card rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">
          {{ 'common.recipientData' | translate }}
        </div>
      </div>
      <div class="card-body">
        <form [formGroup]="countryForm">
          <div class="row">
            <ng-container *ngFor="let f of CASHIN_COUNTRY_FIELDS[originCurrency]">
              <div class="col-lg-6 col-sm-6 mb-3">
                <label class="form-label">{{ f.label | translate }} <span class="text-danger">*</span></label>
                <input class="form-control"
                       [formControlName]="f.name"
                       [ngClass]="{'is-invalid state-invalid': countryForm.controls[f.name].invalid && isCountryFormSubmitted}">
              </div>
            </ng-container>
          </div>

          <button type="button"
                  class="our-button btn btn-pill btn-primary"
                  (click)="confirmCountryForm()">
            <i class="fe fe-check"></i> {{ 'common.confirmButton' | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row mt-4" *ngIf="depositSuccess">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
    <div class="card-header">
      <div class="card-title mb-0">{{ 'common.paymentInformation' | translate }}</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-sm-12 mb-5 text-center">
          <h5 class="text-center">{{ 'common.linkToCheckout' | translate }}</h5>
          <textarea class="form-control" [ngModel]="checkoutUrl" disabled></textarea>
        </div>
        <div class="col-xl-12 col-lg-12 col-sm-12 text-center mt-3 mt-sm-0">
          <h5 class="text-center">{{ 'common.actions' | translate }}</h5>
          <div class="d-flex justify-content-center gap-2">
            <button class="our-button btn btn-pill btn-primary"
                    placement="top"
                    ngbPopover="Copiado!"
                    [cdkCopyToClipboard]="checkoutUrl">
              {{ 'common.copyButton' | translate }}
            </button>
            <button class="our-button btn btn-pill btn-primary"
                    (click)="openCheckoutUrl()">
              {{ 'common.accessButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

